/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomeggookGoodsVo } from './DomeggookGoodsVo';
import {
    DomeggookGoodsVoFromJSON,
    DomeggookGoodsVoFromJSONTyped,
    DomeggookGoodsVoToJSON,
    DomeggookGoodsVoToJSONTyped,
} from './DomeggookGoodsVo';

/**
 * 
 * @export
 * @interface ResponseDomeggookGoodsVo
 */
export interface ResponseDomeggookGoodsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseDomeggookGoodsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseDomeggookGoodsVo
     */
    message?: string;
    /**
     * 
     * @type {DomeggookGoodsVo}
     * @memberof ResponseDomeggookGoodsVo
     */
    data?: DomeggookGoodsVo;
}

/**
 * Check if a given object implements the ResponseDomeggookGoodsVo interface.
 */
export function instanceOfResponseDomeggookGoodsVo(value: object): value is ResponseDomeggookGoodsVo {
    return true;
}

export function ResponseDomeggookGoodsVoFromJSON(json: any): ResponseDomeggookGoodsVo {
    return ResponseDomeggookGoodsVoFromJSONTyped(json, false);
}

export function ResponseDomeggookGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseDomeggookGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : DomeggookGoodsVoFromJSON(json['data']),
    };
}

export function ResponseDomeggookGoodsVoToJSON(json: any): ResponseDomeggookGoodsVo {
    return ResponseDomeggookGoodsVoToJSONTyped(json, false);
}

export function ResponseDomeggookGoodsVoToJSONTyped(value?: ResponseDomeggookGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': DomeggookGoodsVoToJSON(value['data']),
    };
}

